import Production from "../../../Dashboard/Components/production-section/Production";
import * as type from "../../types/API/production";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
  documents: [],
  production: {},
  message: ''
};

export const startProductionReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.START_PRODUCTION:
      return {
        ...state,
        loading: true,
      };
    case type.START_PRODUCTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData.productions,
      };
    case type.START_PRODUCTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getProductionsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_PRODUCTION:
      return {
        ...state,
        loading: true,
      };
    case type.GET_PRODUCTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: action.payload.responseData.salesDocuments,
      };
    case type.GET_PRODUCTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getProductionByIdReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_PRODUCTION_BY_ID:
      return {
        ...state,
        loading: true,
      };
    case type.GET_PRODUCTION_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        production: action.payload.responseData.productionData,
      };
    case type.GET_PRODUCTION_BY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getBulkProductionReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BULK_PRODUCTION:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BULK_PRODUCTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_BULK_PRODUCTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getRemainingProductionReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_REMAINING_PRODUCTION:
      return {
        ...state,
        loading: true,
      };
    case type.GET_REMAINING_PRODUCTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.remainingProduction || [],
      };
    case type.GET_REMAINING_PRODUCTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateProcessReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_PROCESS:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message
      };
    case type.UPDATE_PROCESS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateCostReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_COST:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_COST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message
      };
    case type.UPDATE_COST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const saveFinishedGoodsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.SAVE_FINISHED_GOODS:
      return {
        ...state,
        loading: true,
      };
    case type.SAVE_FINISHED_GOODS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message
      };
    case type.SAVE_FINISHED_GOODS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const saveReworkReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.SAVE_REWORK:
      return {
        ...state,
        loading: true,
      };
      case type.SAVE_REWORK_SUCCESS: 
        return { 
          ...state,
          loading: false,
          error: null,
          message: action.payload.responseData?.message 
        }; 
      case type.SAVE_REWORK_FAILED: 
      return {
        ...state,
        loading: false,
        error: action.payload.error
        };
      default: return state;
    }
};

export const updateProductionStatusReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_PRODUCTION_STATUS:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_PRODUCTION_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message
      };
    case type.UPDATE_PRODUCTION_STATUS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const updateScrapLogsStatusReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_SCRAP_LOGS:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_SCRAP_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message
      };
    case type.UPDATE_SCRAP_LOGS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const saveProductionReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.SAVE_PRODUCTION:
      return {
        ...state,
        loading: true,
      };
    case type.SAVE_PRODUCTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message
      };
    case type.SAVE_PRODUCTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const materialPlanningReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.MATERIAL_PLANNING:
      return {
        ...state,
        loading: true,
      };
    case type.MATERIAL_PLANNING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message,
        data: action.payload.responseData.materialPlanningData
      };
    case type.MATERIAL_PLANNING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const minStockMaterialPlanningReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.MIN_STOCK_MATERIAL_PLANNING:
      return {
        ...state,
        loading: true,
      };
    case type.MIN_STOCK_MATERIAL_PLANNING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message,
        data: action.payload.responseData.materialPlanningData
      };
    case type.MIN_STOCK_MATERIAL_PLANNING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const bomBasedMaterialPlanningReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.BOM_BASED_MATERIAL_PLANNING:
      return {
        ...state,
        loading: true,
      };
    case type.BOM_BASED_MATERIAL_PLANNING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message,
        data: action.payload.responseData.materialPlanningData
      };
    case type.BOM_BASED_MATERIAL_PLANNING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const getProductionsByCompanyIdReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_PRODUCTIONS_BY_COMPANY_ID:
      return {
        ...state,
        loading: true,
      };
    case type.GET_PRODUCTIONS_BY_COMPANY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message,
        data: action.payload.responseData.productions
      };
    case type.GET_PRODUCTIONS_BY_COMPANY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const productionBasedMaterialPlanningReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.PRODUCTION_BASED_MATERIAL_PLANNING:
      return {
        ...state,
        loading: true,
      };
    case type.PRODUCTION_BASED_MATERIAL_PLANNING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message,
        data: action.payload.responseData.materialPlanningData
      };
    case type.PRODUCTION_BASED_MATERIAL_PLANNING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const updateTableReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_TABLE:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_TABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message,
      };
    case type.UPDATE_TABLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const removeRowsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.REMOVE_ROWS:
      return {
        ...state,
        loading: true,
      };
    case type.REMOVE_ROWS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.responseData?.message,
      };
    case type.REMOVE_ROWS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const viewProductionHistoryReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.VIEW_PRODUCTION_HISTORY:
      return {
        ...state,
        loading: true,
      };
    case type.VIEW_PRODUCTION_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.data,
      };
    case type.VIEW_PRODUCTION_HISTORY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const returnRawMaterialReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.RETURN_RAW_MATERIAL:
      return {
        ...state,
        loading: true,
      };
    case type.RETURN_RAW_MATERIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.RETURN_RAW_MATERIAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const startBulkProductionReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.START_BULK_PRODUCTION:
      return {
        ...state,
        loading: true,
      };
    case type.START_BULK_PRODUCTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.data,
      };
    case type.START_BULK_PRODUCTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const getBulkProductionsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BULK_PRODUCTIONS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BULK_PRODUCTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.bulkProductions,
      };
    case type.GET_BULK_PRODUCTIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const discardProductionReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DISCARD_PRODUCTION:
      return {
        ...state,
        loading: true,
      };
    case type.DISCARD_PRODUCTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.DISCARD_PRODUCTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const bulkIssueReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.BULK_ISSUE:
      return {
        ...state,
        loading: true,
      };
    case type.BULK_ISSUE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.BULK_ISSUE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const updateStartDateReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_START_DATE:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_START_DATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.UPDATE_START_DATE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const getAllProductionsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_ALL_PRODUCTIONS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_ALL_PRODUCTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.productionsIds,
      };
    case type.GET_ALL_PRODUCTIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const deleteLogsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_LOGS:
      return {
        ...state,
        loading: true,
      };
    case type.DELETE_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.DELETE_LOGS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}